var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMedicalExpenses(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#0B966B",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90 8 8)",
    x: 5.5,
    y: 0.5,
    width: 5,
    height: 15,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 0.5,
    width: 5,
    height: 15,
    rx: 1
  }))));
}
export default SvgIconMedicalExpenses;